import React from 'react';

// import { Checkbox, makeStyles, Theme } from '@material-ui/core';
// import Check from '@material-ui/icons/Check';
// import Close from '@material-ui/icons/Close';

import { useToggle } from '../../hooks';
import Check from '../svg/Check';
import Cancel from '../svg/Cancel';
import IconButton from '../ActionIcons/IconButton';
import Checkbox from '../svg/Checkbox';
import CheckboxOut from '../svg/CheckboxOut';

interface IEditCheckboxProps {
  value: boolean;
  readonly?: boolean;
  onChange: (newValue: boolean) => void;
}

export default function EditCheckbox({
  value,
  readonly = false,
  onChange
}: IEditCheckboxProps) {
  const [_checkboxValue, toggleCheckboxValue] = useToggle(value);
  const handleCheckboxChange = () => {
    onChange(!_checkboxValue);
    toggleCheckboxValue();
  };

  if (readonly) {
    return value ? <Check /> : <Cancel />;
  }

  return (
    <>
      <IconButton onClick={handleCheckboxChange}>
        {_checkboxValue? <Checkbox />: <CheckboxOut />}
      </IconButton>
      {/* <input type='checkbox' checked={_checkboxValue} onChange={handleCheckboxChange} /> */}
    </>
  );
}
